<script setup lang="ts">
import VistaTask from '../components/VistaTask.vue';

definePage({ meta: { titolo: 'I miei task' } });
</script>

<template>
  <VistaTask ambito="miei" testo-vuoto="Non hai task assegnati con questi filtri.">
    <template #intestazione>
      <p class="text-xs font-semibold tracking-[0.08em] text-ink-muted uppercase">Attività</p>
      <h1 class="mt-1 font-display text-[33px] leading-[1.07] font-semibold">I miei task</h1>
      <p class="mt-1 hidden text-[13px] text-ink-secondary sm:block">
        Le attività assegnate a te, dalla scadenza più vicina.
      </p>
    </template>
  </VistaTask>
</template>
